import { useCallback } from 'react';
import { useDictionary } from './UseDictionary';

const useRatingPhrase = () => {
  let dictionary = useDictionary();
  const getPhrase = useCallback((rating) => {
    switch (rating) {
      case 5:
        return dictionary.rating5;
      case 4:
        return dictionary.rating4;
      case 3:
        return dictionary.rating3;
      case 2:
        return dictionary.rating2;
      case 1:
        return dictionary.rating1;
      default:
        return dictionary.rating1;
    }
  }, []);

  return { getPhrase };
};

export default useRatingPhrase;